var ResultStatus;
(function (ResultStatus) {
  ResultStatus[ResultStatus["InProgress"] = 1] = "InProgress";
  ResultStatus[ResultStatus["InReview"] = 2] = "InReview";
  ResultStatus[ResultStatus["Complete"] = 3] = "Complete";
  ResultStatus[ResultStatus["Pending"] = 4] = "Pending";
  ResultStatus[ResultStatus["Reject"] = 5] = "Reject";
  ResultStatus[ResultStatus["RejectResolved"] = 6] = "RejectResolved";
  ResultStatus[ResultStatus["Discard"] = 7] = "Discard";
})(ResultStatus || (ResultStatus = {}));

export { ResultStatus as R };
